import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import reportWebVitals from "./utils/reportWebVitals";
import App from "./App";

import "./mocks";

import { ThemeProvider } from "./contexts/ThemeContext";
import { DialogProvider } from "dialog-hook";
import "./styleDialog.css";

const Dialog = ({ title, message }) => (
  <div className="Backdrop">
    <div className="Alert">
      <h3>{title}</h3>
      <h4>{message}</h4>
      <div className="Actions">
        <button name="cancel" type="button">
          Cancel
        </button>
        <button id="ok" name="ok" type="button">
          OK
        </button>
      </div>
    </div>
  </div>
);

ReactDOM.render(
  <BrowserRouter>
    <ThemeProvider>
      <DialogProvider Component={(props) => <Dialog {...props} />}>
        <App />
      </DialogProvider>
    </ThemeProvider>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
